// eslint-disable-next-line no-restricted-imports
import { NotificationListItemFragment } from 'api/generated/graphql';
import { NotificationSettingsType } from 'api/types/data';
import { NotificationEntity } from 'api/types/entity';

import { parseClientOnboardingStatus } from '../client/parseEntity/parseClientOnboardingStatus';

export const parseNotificationEntity = (
  notification: NotificationListItemFragment
): NotificationEntity => ({
  id: notification.id,
  isRead: !!notification.readAt,
  createdAt: new Date(notification.createdAt),
  type: NotificationSettingsType[notification.type],
  payload: {
    clientFullName: notification.payload.clientFullName,
    clientId: notification.payload.clientId,
    clientType: notification.payload.clientType,
    currentOnboardingStatus: parseClientOnboardingStatus(
      notification.payload.currentOnboardingStatus
    ),
    prevOnboardingStatus: parseClientOnboardingStatus(
      notification.payload.prevOnboardingStatus
    ),
  },
});
